import { clearArcade } from 'arcade/actions';
import React, { Component } from 'react';
import ArcadeForm from './sections/arcade';
import CabinetsSection from './sections/cabinets';
import RoomsSection from './sections/rooms';
import './sections/sections.less';

interface ArcadeProps {
    readonly modeType: string;
    readonly arcadeId: string;
    readonly clearArcade: typeof clearArcade;
    readonly path: string;
    readonly hasArcadeCabinets: boolean;
    RouteComponentProps;
}

class Arcade extends Component<ArcadeProps> {
    componentWillUnmount() {
        this.props.clearArcade();
    }
    render() {
        const { 
            path, 
            arcadeId,
        } = this.props;
        return ( 
            <>
                <div className="row">
                    <div className="col-sm-4">
                        <ArcadeForm arcadeId={arcadeId} path={path} />
                    </div>
                </div>
                { 
                    !!arcadeId &&
                    <CabinetsSection arcadeId={arcadeId} />
                }
                {
                    !!arcadeId &&
                    <RoomsSection arcadeId={arcadeId} />
                }
            </>
        );
    }
}

export default Arcade;
